import { render, staticRenderFns } from "./AIChatbot.vue?vue&type=template&id=ec40733a&scoped=true"
import script from "./AIChatbot.vue?vue&type=script&lang=js"
export * from "./AIChatbot.vue?vue&type=script&lang=js"
import style0 from "./AIChatbot.vue?vue&type=style&index=0&id=ec40733a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_5d0d328ca533c93cad25b3f77b928576/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec40733a",
  null
  
)

export default component.exports